import request from './axios'

//  获取温度
export const getWt =  (params) => {
    return request({
        url: "/bigScreen/getWt",
        method: "get",
        params,
    })
}
export const schoolList =  (params) => {
    return request({
        url: "/bigScreen/schoolList",
        method: "get",
        params,
    })
}

export const sosWaring =  (params) => {
    return request({
        url: "/bigScreen/sosWaring",
        method: "get",
        params,
    })
}

export const sosWaterAreaWaring =  (params) => {
    return request({
        url: "/bigScreen/sosWaterAreaWaring",
        method: "get",
        params,
    })
}

export const statistics =  (params) => {
    return request({
        url: "/bigScreen/statistics",
        method: "get",
        params,
    })
}
export const waterAreaWaring =  (params) => {
    return request({
        url: "/bigScreen/waterAreaWaring",
        method: "get",
        params,
    })
}
export const getUserById =  (params) => {
    return request({
        url: "/menu/getUserById",
        method: "get",
        params,
    })
}
export const findUserDeviceLocation =  (params) => {
    return request({
        url: "/device/findUserDeviceLocation",
        method: "get",
        params,
    })
}
export const organizationList =  (params) => {
    return request({
        url: "/bigScreen/organizationList",
        method: "get",
        params,
    })
}
// //添加或修改用户
// export const menusaveOrUpdateUser =  (params) => {
//     return request({
//         url: "/menu/saveOrUpdateUser",
//         method: "post",
//         data:params,
//     })
// }